//审核管理相关接口
import request from '../utils/axios'

 // 获取采伐者申请列表（工作人员）
export function GetFellLis(params) {
  return request({
    url: "/Examine/GetFellLis",
    method: 'post',	
		data:params
  })
}

// 获取采伐者申请详情
export function GetFellDetail(params) {
  return request({
    url: `/Examine/GetFellDetail?id=${params.id}`,
    method: 'get',	
  })
}

// 审核采伐者
export function ExamineFell(params) {
  return request({
    url: "/Examine/ExamineFell",
    method: 'post',	
		data:params
  })
}

 // 获取加工厂/集材场申请列表(工作人员)
export function GetFacLis(params) {
  return request({
    url: "/Examine/GetFacLis",
    method: 'post',	
		data:params
  })
}

// 获取加工厂/集材场申请详情
export function GetFacDetail(params) {
  return request({
    url: `/Examine/GetFacDetail?id=${params.id}`,
    method: 'get',	
  })
}

// 审核加工厂/集材场
export function ExamineFac(params) {
  return request({
    url: "/Examine/ExamineFac",
    method: 'post',	
		data:params
  })
}

// 获取伐区和伐区乡镇采伐量统计数据（工作人员）
export function GetExamineCount(params) {
  return request({
    url: '/Examine/GetExamineCount',
    method: 'get',	
  })
}

// 获取加工厂/集材场位置（工作人员）
export function GetAllFacGeo(state) {
  return request({
    url: `/Examine/GetAllFacGeo?state=${state}`,
    method: 'get',	
  })
}